/*
 * Shared polite live region for status messages (WCAG 4.1.3).
 * Usage: window.StashLiveRegion.announce('Chamomile quantity updated to 4.');
 * The container is created once at load and stays in the DOM, since screen
 * readers only reliably announce changes to a region that already existed.
 */
(function () {
  if (window.StashLiveRegion) return;

  let region = null;
  let timer = null;

  function ensureRegion() {
    if (region && region.isConnected) return region;
    region = document.createElement('div');
    region.id = 'StashLiveRegion';
    region.className = 'visually-hidden';
    region.setAttribute('role', 'status');
    region.setAttribute('aria-live', 'polite');
    region.setAttribute('aria-atomic', 'true');
    document.body.appendChild(region);
    return region;
  }

  window.StashLiveRegion = {
    announce(message) {
      const el = ensureRegion();
      clearTimeout(timer);
      // Clearing first lets an identical message be announced again.
      el.textContent = '';
      timer = setTimeout(() => {
        el.textContent = message;
      }, 100);
    },
  };

  ensureRegion();
})();
